export default __webpack_public_path__ + "static/media/afr_1.bf4405a5.png";